import $ from 'jquery';

$(document).on('gform_confirmation_loaded', function (event, formId){
	window.dataLayer = window.dataLayer || [];
	dataLayer.push({
		'event': 'g_form_submit',
		'form_id': formId
	});
});